import { render, staticRenderFns } from "./EndorsementOverallRestrictionsModal.vue?vue&type=template&id=7e33e15e&scoped=true"
import script from "./EndorsementOverallRestrictionsModal.vue?vue&type=script&lang=ts"
export * from "./EndorsementOverallRestrictionsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e33e15e",
  null
  
)

export default component.exports